export default __webpack_public_path__ + "tooltip-icon.03ad30c67ae56b5e9c73f03da27af738.svg";